import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
const AddTruck = () => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:'',
    desc:''
  });
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };
  const [jobsData , setJobData] = useState([])
  const fetchJobs = async ()=>{
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let response = await fetch("https://api.towrankers.com/api/affiliates/fetch-affiliates", { 
         method: "GET",
         headers: headersList
       });
       let data = await response.json();
       const formattedData = data.map((e) => ({
        value: e.id,
        label: e.business_name
      }));
      setJobData(formattedData)
}
React.useEffect(()=>{
  fetchJobs()
},[1])

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
    
  };
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const onFormSubmit = async (event) =>{
    event.preventDefault();
    if(isValidEmail(event.target.elements.email_address.value) === false){
      setshowAlertMessage({
        message: 'error',
        status:true,
        desc:'Email address is invalid'
      });
      return false;
    }else{

      let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         
         let bodyContent = JSON.stringify({
           "name": event.target.elements.fullname.value,
           "email": event.target.elements.email_address.value,
           "password":event.target.elements.password.value,
           "role" : event.target.elements.role.value,
         });
         
         let response = await fetch("https://api.towrankers.com/api/user/create", { 
           method: "POST",
           body: bodyContent,
           headers: headersList
         });
         
      //    let data = await response.text();
       
       let data = await response.json();
       if(response.status == 201){
        setshowAlertMessage({
          message: 'success',
          status:true,
          desc:'User Is added successfully'
        });
        event.target.elements.fullname.value='';
        event.target.elements.email_address.value='';
        event.target.elements.password.value='';
       }else{
  
  
        setshowAlertMessage({
          message: 'error',
          status:true,
          desc:'Error while adding new user'
        });
       }
    }
     
  }
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Add Truck" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                <div className="card border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>onFormSubmit(event)}>
                    

                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Name <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          className="form-control radius-8"
                          id="name"
                          
                          placeholder="Enter Full Name"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="truck_type"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Type
                        </label>
                         <select
                          className="form-control radius-8"
                          id="truck_type"
                          name="truck_type"
                          >
                            
                            <option> Unspecified</option>
                            <option> Wrecker</option>
                            <option> Flat Bed</option>
                            <option>  Other</option>
                            <option>  Service Vehicle</option>
                            <option>  Rotator</option>
                            <option>  Tractor</option>
                            <option>  Trailer</option>
                            <option> Container</option>
                            <option> Hazmat</option>
                          </select>
                        
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="truck_duty"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Duty
                        </label>
                         <select
                          className="form-control radius-8"
                          id="truck_duty"
                          name="truck_duty"
                          >
                            <option>Unspecified</option>
                            <option>Medium</option>
                            <option>Heavy</option>
                            <option>Other</option>
                            <option>Light</option>
                          </select>
                        
                      </div>
                   
                     
                    
                      {
                      showAlertMessage.status === true?
                    <div
                        className={
                          showAlertMessage.message == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessage.desc}
                        <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                   
                      <div className="d-flex align-items-center justify-content-center gap-3">
                   
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default AddTruck;
